import { RouteObject } from 'react-router';
import { lazy } from 'react';

// project imports
import { AppModule, Routes } from 'utils/constants';
import Loadable from 'components/loading/Loadable';
import MainLayout from 'components/layout/MainLayout/MainLayout';
import { DispatcherRoutes } from 'models/routes';

// routing
const OnlineDispatching = Loadable(
  lazy(
    () => import('views/modules/Dispatcher/OnlineDispatching/OnlineDispatching')
  )
);
const OnlineDispatchingDeliveryPoint = Loadable(
  lazy(
    () =>
      import(
        'views/modules/Dispatcher/OnlineDispatching/OnlineDispatchingForDP/OnlineDispatchingForDP'
      )
  )
);

const OnlineDispatchingDevice = Loadable(
  lazy(
    () =>
      import(
        'views/modules/Dispatcher/OnlineDispatching/OnlineDispatchingForDevice/OnlineDispatchingForDevice'
      )
  )
);

const ProductionPlanning = Loadable(
  lazy(
    () =>
      import('views/modules/Dispatcher/ProductionPlanning/ProductionPlanning')
  )
);
const OperationCalendar = Loadable(
  lazy(
    () => import('views/modules/Dispatcher/OperationCalendar/OperationCalendar')
  )
);
const ConsumptionPlanning = Loadable(
  lazy(
    () =>
      import('views/modules/Dispatcher/ProductionPlanning/ConsumptionPlanning')
  )
);
const HxDashboard = Loadable(
  lazy(() => import('views/modules/Dispatcher/HxDashboard/HxDashboard'))
);
const RkDashboard = Loadable(
  lazy(() => import('views/modules/Dispatcher/RkDashboard/RkDashboard'))
);

// ==============================|| DISPATCHER ROUTES ||============================== //

const routesDispatcher: RouteObject = {
  path: `${Routes.BASE_PATH}:tenant`,
  element: <MainLayout module={AppModule.DISPATCHER} />,
  children: [
    {
      path: Routes.DISPATCHER.ONLINE_DISPATCHING_PATH,
      element: <OnlineDispatching />
    },
    {
      path: Routes.DISPATCHER.ONLINE_DISPATCHING_BALANCING_GROUP_ID_PATH,
      element: <OnlineDispatching />
    },
    {
      path: Routes.DISPATCHER.ONLINE_DISPATCHING_DELIVERY_POINT_PATH,
      element: <OnlineDispatchingDeliveryPoint />
    },
    {
      path: Routes.DISPATCHER.ONLINE_DISPATCHING_DEVICE_PATH,
      element: <OnlineDispatchingDevice />
    },
    {
      path: Routes.DISPATCHER.PRODUCTION_PLANNING_PATH,
      element: <ProductionPlanning />
    },
    {
      path: Routes.DISPATCHER.OPERATION_CALENDAR_PATH,
      element: <OperationCalendar />
    },
    {
      path: Routes.DISPATCHER.CONSUMPTION_PLANNING_PATH,
      element: <ConsumptionPlanning />
    },
    {
      path: Routes.DISPATCHER.HX_DASHBOARD,
      element: <HxDashboard />
    },
    {
      path: DispatcherRoutes.RK_DASHBOARD,
      element: <RkDashboard />
    }
  ]
};

export default routesDispatcher;
